const path = `/v2/organization/analyst/apikeys`;
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  async function get() {
    const response = await repository.get(path);
    return response && response.data ? response.data.apikeys || [] : [];
  }
  async function create() {
    const response = await repository.post(path);
    return response && response.data ? response.data.key || null : null;
  }
  async function remove({ key } = {}) {
    const response = await repository.delete(`${path}/${key}`);
    return !!response;
  }
  return Object.freeze({
    get,
    create,
    remove
  });
}
